import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-28a1965e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "dj-tabs"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode(" 查看详情 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _component_el_table_column = _resolveComponent("el-table-column");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_table = _resolveComponent("el-table");

  var _component_Pagination = _resolveComponent("Pagination");

  var _directive_loading = _resolveDirective("loading");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "我的通知",
    back: false
  }), _createElementVNode("div", _hoisted_1, [_withDirectives(_createVNode(_component_el_table, {
    "show-header": false,
    data: _ctx.tableData,
    style: {
      "width": "100%"
    },
    "empty-text": "暂无数据",
    "element-loading-text": _ctx.tableloading,
    class: "el-table-index"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        label: "name",
        width: "500"
      }, {
        default: _withCtx(function (scoped) {
          return [_createElementVNode("span", null, _toDisplayString(scoped.row.title), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "createTime",
        label: "time",
        width: "200"
      }), _createVNode(_component_el_table_column, {
        label: "operate",
        align: "left"
      }, {
        default: _withCtx(function (scoped) {
          return [_createVNode(_component_el_button, {
            type: "text",
            class: "btn-detail",
            onClick: function onClick($event) {
              return _ctx.getDetail(scoped.row.noticeId);
            }
          }, {
            default: _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 2
          }, 1032, ["onClick"])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["data", "element-loading-text"]), [[_directive_loading, _ctx.loading]]), _createVNode(_component_Pagination, {
    pagesize: 10,
    "total-num": _ctx.totalNum,
    onChangPage: _ctx.changPage
  }, null, 8, ["total-num", "onChangPage"])])], 64);
}